import { render, staticRenderFns } from "./PaymentFinished.vue?vue&type=template&id=003f066c&"
import script from "./PaymentFinished.vue?vue&type=script&lang=js&"
export * from "./PaymentFinished.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFinished.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports